import bibleBookList from "../data/BookChapterList.json"

const pad = (num, size) => {
  var s = num + ""
  while (s.length < size) s = "0" + s
  return s
}

export const sortGapTestamentData = verseArray => {
  if (verseArray.length !== 0) {
    const verseOrderedArray = verseArray.sort((a, b) => {
      let verseA = a.split(" ")[1].split(":")[1]
      let verseB = b.split(" ")[1].split(":")[1]
      if (verseA.search("-") !== -1) {
        verseA = verseA.split("-")[0]
      }
      if (verseB.search("-") !== -1) {
        verseB = verseB.split("-")[0]
      }

      verseA = pad(verseA, 3)
      verseB = pad(verseB, 3)

      return verseA < verseB ? -1 : verseA > verseB ? 1 : 0
    })
    const chapterOrderedArray = verseOrderedArray.sort((a, b) => {
      let chapterA = a.split(" ")[1].split(":")[0]
      let chapterB = b.split(" ")[1].split(":")[0]
      chapterA = pad(chapterA, 3)
      chapterB = pad(chapterB, 3)
      return chapterA < chapterB ? -1 : chapterA > chapterB ? 1 : 0
    })
    const bookOrderedArray = chapterOrderedArray.sort((a, b) => {
      const bookA = a.split(" ")[0]
      const bookB = b.split(" ")[0]
      const bibleBookOrder = Object.keys(bibleBookList)
      return bibleBookOrder.indexOf(bookA) - bibleBookOrder.indexOf(bookB)
    })
    return bookOrderedArray
  } else {
    return []
  }
}
